import React, { useState } from 'react'
import './styles.scss'
interface Props {
  children: JSX.Element | string
  embeded?: boolean
}
export const ChartSettings = ({ children, embeded = false }: Props) => {
  const [isOpen, setOpen] = useState<boolean>(false)
  return (
    <div
      className={
        'ChartSettings ' +
        (isOpen ? 'open' : '') +
        ' ' +
        (embeded === true ? 'emb' : '')
      }
    >
      <div
        className='indicator_icon'
        onClick={() => {
          setOpen(!isOpen)
        }}
      />
      {/* <img src={require('images/settings_'+(isOpen?'close':'open')+'.svg')} onClick={()=>{setOpen(!isOpen)}}/> */}
      <div className='content'> {isOpen && children}</div>
    </div>
  )
}
